<template>
    <div>

        <rkm-area
            v-if="data.form.examesAvaliados.length > 0"
            class="mb-2"
            no-margin-top
            title="Exames Avaliados"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col
                    v-for="(exameAvaliado, index) in data.form.examesAvaliados"
                    :key="index"
                    class="mb-2"
                    cols="6"
                >
                    <rkm-list-group>
                        <rkm-list-group-item class="rkm-list-group-item">
                            <rkm-row>
                                <rkm-col
                                    class="align-self-center"
                                    cols="12"
                                >
                                    <rkm-form-checkbox
                                        checked
                                        disabled
                                    >
                                        {{exameAvaliado.descricao}}
                                    </rkm-form-checkbox>
                                </rkm-col>
                            </rkm-row>
                        </rkm-list-group-item>
                    </rkm-list-group>

                    <rkm-collapse
                        class="rkm-collapse"
                        visible
                    >
                        <rkm-row class="p-2">

                            <rkm-col cols="6">
                                <rkm-form-date-picker
                                    label="Data da solicitação"
                                    v-model="exameAvaliado.solicitadoEm"
                                    readonly
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-date-picker
                                    label="Data da realização"
                                    v-model="exameAvaliado.realizadoEm"
                                    readonly
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-date-picker
                                    label="Data do resultado"
                                    v-model="exameAvaliado.resultadoEm"
                                    readonly
                                />
                            </rkm-col>

                            <rkm-col cols="12">
                                <rkm-form-textarea
                                    :value="exameAvaliado.resultado"
                                    readonly
                                    rows="6"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>
            <rkm-col
                v-for="(exame, index) in exameAvaliado"
                :key="index"
                class="mb-2"
                cols="6"
            >
                <rkm-list-group>
                    <rkm-list-group-item class="rkm-list-group-item">
                        <rkm-row>
                            <rkm-col
                                class="align-self-center"
                                cols="12"
                            >
                                <rkm-form-checkbox
                                    :checked="!!data.model.exameAvaliado.find(t => t.id === exame.id)"
                                    @change.native="handleExameAvaliadoChange($event, exame.id)"
                                >
                                    {{exame.descricao}}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>

                <rkm-collapse
                    :visible="!!data.model.exameAvaliado.find(t => t.id === exame.id)"
                    class="rkm-collapse"
                >
                    <rkm-row class="p-2">

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                v-if="data.model.exameAvaliado.find(t => t.id === exame.id)"
                                :max-date="data.additionals.dataAtual"
                                label="Data da solicitação"
                                v-model="data.model.exameAvaliado.find(t => t.id === exame.id).solicitadoEm"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                v-if="data.model.exameAvaliado.find(t => t.id === exame.id)"
                                :max-date="data.additionals.dataAtual"
                                label="Data da realização"
                                :min-date="others.moment(data.model.exameAvaliado.find(t => t.id === exame.id).solicitadoEm).format('DD/MM/YYYY')"
                                v-model="data.model.exameAvaliado.find(t => t.id === exame.id).realizadoEm"
                                :validations="validations.realizadoEm"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                v-if="data.model.exameAvaliado.find(t => t.id === exame.id)"
                                :max-date="data.additionals.dataAtual"
                                label="Data do resultado"
                                :min-date="others.moment(data.model.exameAvaliado.find(t => t.id === exame.id).realizadoEm).format('DD/MM/YYYY')"
                                v-model="data.model.exameAvaliado.find(t => t.id === exame.id).resultadoEm"
                            />
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-textarea
                                v-if="data.model.exameAvaliado.find(t => t.id === exame.id)"
                                :validations="validations.resultado"
                                label="Resultado"
                                rows="6"
                                v-model="data.model.exameAvaliado.find(t => t.id === exame.id).resultado"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-collapse>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Others.
import moment from 'moment'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'
import exameSolicitadoAvaliado from '@/enums/atencao-basica/atendimento-individual/exameSolicitadoAvaliado'

export default {
    computed: {
        validations() {
            return {
                resultado: {
                    required: true,
                    max: 5000,
                },
                realizadoEm: {required: true},
            }
        },
        exameAvaliado() {
            return this.data.additionals.paciente.sexoId == this.enums.sexo.FEMININO
                && this.data.additionals.paciente.idadeAnos > 9 && this.data.additionals.paciente.idadeAnos < 60
                ? this.data.form.exameSolicitadoAvaliado
                : this.data.form.exameSolicitadoAvaliado.filter(exame => exame.id != this.enums.exameSolicitadoAvaliado.TESTE_DE_GRAVIDEZ)
        }
    },
    data: () => ({
        others: {moment},
        enums: {sexo, exameSolicitadoAvaliado},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleExameAvaliadoChange(event, id) {

            if (event.target.checked) {
                this.data.model.exameAvaliado.push({
                    id: parseInt(id),
                    resultado: null,
                })
            } else {
                this.data.model.exameAvaliado.splice(this.data.model.exameAvaliado.findIndex(exame => exame.id === parseInt(id)) , 1)
            }
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.2rem 0.2rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>